import { mui, React, ts } from '_core';

import AlphaModelForm from './alpha-form';
import SignalForm from './custom-form';

type SignalFormProps = {
  open: boolean;
  setOpen: (_open: boolean) => void;
  type?: ts.enums.SIGNAL_TYPE_ENUM;
};

const MainSignalForm = ({ open, setOpen, type = ts.enums.SIGNAL_TYPE_ENUM.SIGNAL }: SignalFormProps) => {
  const [errorMessage, setErrorMessage] = React.useState('');

  return (
    <mui.core.Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      {errorMessage && (
        <mui.core.Alert onClose={() => setErrorMessage('')} severity="error">
          {errorMessage}
        </mui.core.Alert>
      )}
      {type == 'ALPHA_MODEL' && <AlphaModelForm setErrorMessage={setErrorMessage} close={() => setOpen(false)} />}
      {type == 'SIGNAL' && <SignalForm setErrorMessage={setErrorMessage} close={() => setOpen(false)} />}
    </mui.core.Dialog>
  );
};

export default MainSignalForm;
